(function() {
	'use strict';
	angular.module('app.core')
		.service('commentsService', commentsService);
	
	commentsService.$inject = ['$http', 'URLS'];
	function commentsService($http, URLS) {
		return {
			saveComment: saveComment
		};
		
		function saveComment(leanDirFactoryNdx, type, comment) {
			comment.leanDirFactoryNdx = leanDirFactoryNdx;
			var url = URLS.host + URLS.prefix + leanDirFactoryNdx + '/Comment/Type/' + type;
			return $http.put(url, comment)
				.then(saveCommentSuccess)
				.catch(saveCommentFailed);
			
			function saveCommentSuccess(response) {
				return response.data;
			}
			
			function saveCommentFailed(error) {
				return error;
			}
		}
	}
})();
